import { useEffect, useState } from 'react';
import { getRawData } from '../../services/front_api';
import { ModuleRegistry, createGrid } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { useTheme } from '../../context/ThemeContext';

const SimpleGrid = ({ app, query, debugUpdater }) => { // Ajout de la prop 'title'
    const { themeName } = useTheme();
    const [rowData, setRowData] = useState(null);
    const [title, setTitle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    ModuleRegistry.registerModules([AllEnterpriseModule]);
    LicenseManager.setLicenseKey("CompanyName=BlackBee,LicensedApplication=nVisio,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-013902,ExpiryDate=25_March_2022_[v2]_MTY0ODE2NjQwMDAwMA==88d19d92c49d3c8107233f1da288adaf");

    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([
        { field: "categorie", rowGroup: true },
        { field: "foreigner", rowGroup: true },
        { field: "type", rowGroup: true },
        { field: "ssrm_jour", pivot: true },
        // {
        //     headerName: 'Mois',
        //     colId: 'mois',
        //     valueGetter: params => {
        //     const d = params.data?.ssrm_date;
        //     return d ? d.slice(0, 7) : null; // 'YYYY-MM'
        //     },
        //     sortable: true,
        //     pivot: true,
        //     filter: 'agSetColumnFilter',
        //     // Pour que le Set Filter affiche les bons items en SSRM:
        //     filterValueGetter: p => p.data?.ssrm_date?.slice(0, 7),
        // },
        // {
        //     headerName: 'Jour',
        //     colId: 'jour',
        //     valueGetter: params => {
        //     const d = params.data?.ssrm_date;
        //     return d ? d.slice(8, 10) : null; // 'DD'
        //     },
        //     sortable: true,
        //     pivot: true,
        //     filter: 'agSetColumnFilter',
        //     filterValueGetter: p => p.data?.ssrm_date?.slice(8, 10),
        // },
        { field: "value", headerName: "Valeur", aggFunc: 'sum' },
    ]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [response, url, body] = await getRawData(app, query, 'grid');
                const { data, title } = response;
                setRowData(data);
                setTitle(title);
                debugUpdater(response, url, body);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
                setError(null);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div>Chargement...</div>;
    if (error) return <div>Erreur : {error.message}</div>;

    const agThemeClass = themeName === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine';

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        minWidth: 80,
    };

    return (
        <div className={agThemeClass} style={{ height: 500, width: '100%' }}>
            <AgGridReact
                theme={'legacy'}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                rowHeight={32}
                headerHeight={34}
                pagination={true}
                paginationPageSize={50}
                pivotMode={true}
                groupDisplayType={'multipleColumns'}
                animateRows={true}
                debug
            />
        </div>

    )
}

export default SimpleGrid;